export const chartColumns = () => {
  return [
    {
      field: 'goodsType', //
      title: '货物类型',
      width: '150',
      editRender: { name: 'goodsType' },
    },
    {
      field: 'goodsCategory', //
      title: '货物品类',
      width: '140',
      editRender: { name: 'goodsCategory' },
    },
    {
      field: 'goodsModel',
      title: '规格型号',
      width: '140',
      editRender: { name: 'input' },
    },
    {
      field: 'quantity',
      title: '重量/数量',
      width: '140',
      editRender: { name: 'input' },
    },
    {
      field: 'unit',
      title: '单位',
      width: '140',
      editRender: { name: 'input' },
    },
    {
      field: 'price',
      title: '单价/元',
      width: '140',
      editRender: { name: 'price', immediate: true },
    },
    {
      field: 'stockValue',
      title: '在库价值',
      width: '140',
      editRender: { name: 'stockValue', immediate: true },
    },
    {
      field: 'safeValue', //
      title: '安全价值',
      width: '140',
      editRender: { name: 'safeValue', immediate: true },
    },
    {
      field: 'remark',
      title: '备注',
      width: '140',
      editRender: { name: 'remark' },
    },
  ];
};
